// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectPortfolioRealtimeStatisticsMessage } from "../../../../Utils/DirectMessages/DirectPortfolioRealtimeStatisticsMessage.js"
import { DirectPortfolioStatistic } from "../../../../Utils/DirectMessages/DirectPortfolioStatisticsMessage.js"
export let PortfolioStatisticsMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

PortfolioStatisticsMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

PortfolioStatisticsMessageProcessor.prototype.decode = function (fieldSet)
{
    let message = new DirectPortfolioRealtimeStatisticsMessage(),
        ff = FieldsFactory,
        groups = this.getGroupsFromFieldSet(fieldSet)

    this.ProcessGroups(groups, message)

    return [message];
}

PortfolioStatisticsMessageProcessor.prototype.ProcessGroups = function (groups, message)
{
    if (groups)
        for (let i = 0; i < groups.length; i++)
        {
            let group = groups[i]
            if (group.GroupId === FieldsFactory.PORTFOLIO_MONTHLY_STATISTIC_GROUP)
            {
                this.ProcessGroups(group.fieldSet, message)
                return;
            }
            if (group.FieldId === FieldsFactory.FIELD_GROUP)
                group = group.Value;

            let gr_data = this.readGroupData(group, message);
            message.DataArray.push(gr_data)
        }
}

PortfolioStatisticsMessageProcessor.prototype.readGroupData = function (group)
{
    let directGroup = new DirectPortfolioStatistic();
    let groupLen = group.Count();
    let ff = FieldsFactory

    for (let j = 0; j < groupLen; j++)
    {
        let field = group.fieldSet[j],
            value = field.Value

        switch (field.FieldId)
        {
            case ff.FIELD_DATE:
                directGroup.Date = value
                break;
            case ff.FIELD_PERCENT:
                directGroup.Percent = value
                break;
            case ff.FIELD_AMOUNT:
                directGroup.AbsoluteAmount = value
                break;
            case ff.FIELD_TYPE:
                directGroup.IsBest = value == 1
                break;
            case ff.FIELD_TRADABLE_INSTRUMENT_ID:
                directGroup.TradableInstrumentId = value
                break;
            case ff.FIELD_ROUTE_ID:
                directGroup.RouteId = value
                break;
        }
    }

    return directGroup;
}

PortfolioStatisticsMessageProcessor.prototype.getGroupsFromFieldSet = function (fieldSet)
{
    let ff = FieldsFactory,
        groupIds = [ff.PERCENT_ABSOLUTE_ENTRY_GROUP,
        ff.PORTFOLIO_MONTHLY_STATISTIC_GROUP,
        ff.PERCENT_ABSOLUTE_DAY_ENTRY_GROUP,
        ff.PERCENT_ABSOLUTE_DAY_TYPE_ENTRY_GROUP,
        ff.ABSOLUTE_DAY_ENTRY_GROUP,
        ff.PERCENT_DAY_ENTRY_GROUP,
        ff.PERCENT_INSTRUMENT_ROUTE_DAY_ENTRY_GROUP,
        ff.PORTFOLIO_MONTHLY_INSTRUMENT_RETURN_STATISTIC_ENTRY_GROUP,
        ff.PERCENT_DAY_TYPE_ENTRY_GROUP]

    for (let i = 0; i < groupIds.length; i++)
    {
        let groups = fieldSet.GetGroups(groupIds[i])

        if (groups && groups.length)
            return groups   // предполагаем, что в одном fieldSet-е группы только одного типа 
    }

    return null
}